import { createStyles } from '@codeleap/styles'
import { textVariant } from './Text'
import { RadioInputComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createRadioInputVariant = createStyles<RadioInputComposition>

export const RadioInputStyles = {
  default: createRadioInputVariant(theme => {
    const indicatorSize = theme.size.small
    const ellipsisSize = indicatorSize * 0.5
    return {
      wrapper: {
        ...theme.presets.column,
      },
      optionIndicator: {
        ...theme.border({
          color: theme.baseColors.neutralSolid400,
          width: theme.stroke.regular,
        }),
        borderRadius: theme.radius.infinite,
        height: indicatorSize,
        width: indicatorSize,
        ...theme.presets.center,
        cursor: 'pointer',
      },
      'optionIndicator:disabled': {
        ...theme.border({ color: theme.baseColors.neutralSolid300, width: 1 }),
        cursor: 'not-allowed',
      },
      'optionIndicator:selected': {
        ...theme.border({ color: theme.baseColors.primarySolid800, width: 1 }),
        backgroundColor: theme.baseColors.primarySolid800,
      },
      'optionIndicator:selectedDisabled': {
        ...theme.border({ color: theme.baseColors.primarySolid50, width: 1 }),
        backgroundColor: theme.baseColors.primarySolid50,
      },
      optionIndicatorInner: {
        height: ellipsisSize,
        width: ellipsisSize,
        backgroundColor: theme.baseColors.neutralSolid0,
        borderRadius: theme.radius.infinite,
      },
      label: {
        ...textVariant('p2'),
        color: theme.baseColors.neutralSolid700,
        ...theme.spacing.marginBottom(1),
        cursor: 'pointer',
      },
      description: {
        ...textVariant('p4'),
        color: theme.baseColors.neutralSolid700,
        ...theme.spacing.marginBottom(1),
        ...theme.spacing.marginTop(0),
      },
      'label:disabled': {
        cursor: 'not-allowed',
      },
      optionWrapper: {
        ...theme.spacing.marginTop(1),
        ...theme.spacing.marginRight(1),
        ...theme.presets.row,
        ...theme.presets.alignCenter,
      },
      optionSeparator: {
        ...theme.spacing.marginBottom(2),
      },
      optionLabel: {
        ...textVariant('p1'),
        color: theme.baseColors.neutralSolid700,
        ...theme.spacing.marginLeft(1),
      },
      'optionLabel:disabled': {
        color: theme.baseColors.neutralSolid500,
      },
      'optionLabel:selectedDisabled': {
        color: theme.baseColors.neutralSolid500,
      },
      errorMessage: {
        ...textVariant('p4'),
        color: theme.baseColors.redSolid400,
        ...theme.spacing.marginTop(1),
      },
    }
  }),
  'options:vertical': createRadioInputVariant(theme => ({
    innerWrapper: {
      ...theme.presets.column,
      ...theme.presets.alignStart,
    },
  })),
}

StyleRegistry.registerVariants('RadioInput', RadioInputStyles)
